<div [editableInStoryblok]="_editable">
	<vp-map [lat]="latitude()" [long]="longitude()" />
</div>
